import React from 'react';

import { StripeConnectedAccountInfo } from '@flipdish/api-client-typescript';
import { Button } from '@flipdish/ui-library/components/atoms/Button';
import { useMutation } from '@tanstack/react-query';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';

import {
  closeNotifySaving,
  notifyError,
  NotifyProps,
  notifySaved,
  notifySaving,
} from '../../../../../../layouts/Notify/actions';
import { bankingServices } from '../../../../../../services/banking.service';

export type OuterProps = {
  appId: string;
  stripeAccount: StripeConnectedAccountInfo;
  getBankAccountDetails: () => void;
};

type MappedDispatch = ReturnType<typeof mapDispatchToProps>;
type Props = OuterProps & MappedDispatch;

const ManualPayoutVerification = (props: Props) => {
  const {
    appId,
    closeNotifySaving,
    getBankAccountDetails,
    notifyError,
    notifySaved,
    notifySaving,
    stripeAccount,
  } = props;
  const { StripeId, PayoutScheduleInterval } = stripeAccount;

  const isPayoutScheduleIntervalManual =
    PayoutScheduleInterval &&
    PayoutScheduleInterval === StripeConnectedAccountInfo.PayoutScheduleIntervalEnum.Manual;

  const { mutateAsync: approvePayoutSchedule, isPending } = useMutation({
    mutationFn: () => {
      notifySaving();
      return bankingServices.updatePayoutSchedule(appId, StripeId!, 'Weekly');
    },
    onSuccess: () => {
      getBankAccountDetails();
      closeNotifySaving();
      notifySaved();
    },
    onError: () => {
      closeNotifySaving();
      notifyError({ message: 'Error_please_try_again_later', translate: true });
    },
  });

  const { mutateAsync: disapprovePayoutSchedule, isPending: isLoadingDisapprove } = useMutation({
    mutationFn: () => {
      notifySaving();
      return bankingServices.updatePayoutSchedule(appId, StripeId!, 'Manual');
    },
    onSuccess: () => {
      getBankAccountDetails();
      closeNotifySaving();
      notifySaved();
    },
    onError: () => {
      closeNotifySaving();
      notifyError({ message: 'Error_please_try_again_later', translate: true });
    },
  });

  return (
    <>
      {isPayoutScheduleIntervalManual ? (
        <Button
          color="primary"
          size="md"
          isDisabled={isPending || isLoadingDisapprove}
          onPress={() => approvePayoutSchedule()}
          className="w-full sm:w-auto"
        >
          <Translate id="Approve_for_payouts" />
        </Button>
      ) : (
        <Button
          color="secondary-destructive"
          size="md"
          isDisabled={isLoadingDisapprove || isPending}
          onPress={() => disapprovePayoutSchedule()}
          className="w-full sm:w-auto"
        >
          <Translate id="Disapprove_for_payouts" />
        </Button>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  closeNotifySaving: () => dispatch(closeNotifySaving()),
  notifyError: (data: NotifyProps) => dispatch(notifyError(data)),
  notifySaving: () => dispatch(notifySaving({ persist: true })),
  notifySaved: () => dispatch(notifySaved()),
});

const EnhancedComponent = connect(null, mapDispatchToProps)(ManualPayoutVerification);
export { EnhancedComponent as ManualPayoutVerification };
